export default __webpack_public_path__ + "static/media/TV.cb5b0b59.svg";